<template>
  <div style="margin: 0 auto; max-width: 800px;">
    <div class="mt-5 ml-5 mr-5" style="text-align: center;">
      <p class="mt-3 text-left link mb-5" @click="back">Back to Address Book</p>
      <div
        v-if="$store.state.isUserLoggedIn"
        v-bind:class="{ errorShake: isErrorShake }"
        class="mt-1 mb-6 pt-2"
        style="max-width: 600px; background-color: rgb(240, 240, 240); border: 1px solid rgb(130, 130, 130); border-radius: 5px; padding: 30px; margin: 0 auto; box-shadow: 0 0 10px rgb(150, 150, 150)"
      >
        <h2 class="pt-0 mt-0 mb-4" style="text-align: center;">Add Address</h2>

        <div v-if="this.error != ''" style="text-align: left;">
          <v-alert type="error" v-bind="this.error" style="font-weight: bold;">{{this.error}}</v-alert>
        </div>

        <v-form ref="form">
          <div
            class="mb-4"
            style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
          >
            <v-text-field
              background-color="white"
              color="success"
              height="40"
              label="Name"
              v-model="name"
            ></v-text-field>
          </div>
          <div
            class="mb-4"
            style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
          >
            <v-text-field
              background-color="white"
              color="success"
              height="40"
              label="Address Line 1"
              v-model="address1"
            ></v-text-field>
          </div>
          <div
            class="mb-4"
            style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
          >
            <v-text-field
              background-color="white"
              color="success"
              height="40"
              label="Address Line 2"
              v-model="address2"
            ></v-text-field>
          </div>
          <div
            class="mb-4"
            style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
          >
            <v-text-field
              background-color="white"
              color="success"
              height="40"
              label="City"
              v-model="city"
            ></v-text-field>
          </div>
          <div
            class="mb-4"
            style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
          >
            <v-select
              v-model="states"
              :items="statesOptions"
              label="State"
              class="ml-2 mr-2"
              color="green"
            ></v-select>
          </div>
          <div
            class="mb-4"
            style="background-color: white; padding: 5px; border: 1px solid rgb(130, 130, 130); border-radius: 5px; box-shadow: 0 0 5px rgb(150, 150, 150)"
          >
            <v-text-field
              background-color="white"
              color="success"
              height="40"
              label="Zipcode"
              v-model="zipcode"
            ></v-text-field>
          </div>

          <v-row no-gutters>
            <v-col cols="2" sm="1">
              <v-checkbox
                v-model="this.defaultAddress"
                v-on:change="setDefaultBox"
                style="padding: 5px; margin: 0px;"
              ></v-checkbox>
            </v-col>
            <v-col cols="10" sm="11">
              <p class="pt-1" style="text-align: left;">Save as default address</p>
            </v-col>
          </v-row>

          <div style="width: 60%; margin: 0 auto;">
            <v-btn
              class="mb-2"
              style="width: 100%; box-shadow: 0 0 5px rgb(150, 150, 150)"
              height="50"
              color="success"
              @click="updateAddressBook"
            >Save</v-btn>
          </div>
          <div style="width: 60%; margin: 0 auto;">
            <v-btn
              class="mb-2"
              style="width: 100%; box-shadow: 0 0 5px rgb(150, 150, 150); color: white;"
              height="50"
              color="rgb(140,140,140)"
              @click="back"
            >Back</v-btn>
          </div>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import AuthenticationService from "@/services/AuthenticationService";
import UserService from "@/services/UserService";

export default {
  data: () => ({
    name: "",
    address1: "",
    address2: "",
    city: "",
    states: "",
    statesOptions: [
      "Alabama",
      "Alaska",
      "Arizona",
      "Arkansas",
      "California",
      "Colorado",
      "Connecticut",
      "Delaware",
      "District Of Columbia",
      "Florida",
      "Georgia",
      "Hawaii",
      "Idaho",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kansas",
      "Kentucky",
      "Louisiana",
      "Maine",
      "Maryland",
      "Massachusetts",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Montana",
      "Nebraska",
      "Nevada",
      "New Hampshire",
      "New Jersey",
      "New Mexico",
      "New York",
      "North Carolina",
      "North Dakota",
      "Ohio",
      "Oklahoma",
      "Oregon",
      "Pennsylvania",
      "Rhode Island",
      "South Carolina",
      "South Dakota",
      "Tennessee",
      "Texas",
      "Utah",
      "Vermont",
      "Virginia",
      "Washington",
      "West Virginia",
      "Wisconsin",
      "Wyoming"
    ],
    zipcode: "",
    error: "",
    message: "",
    defaultAddress: false,
    isErrorShake: false
  }),
  async mounted() {
    this.scrollToTop();
    try {
      const response = await AuthenticationService.dashboard();
    } catch (error) {
      // Credentials failed. Logout user and instruct them to login
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.error = error.response.data.error;
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    setDefaultBox(value) {
      this.defaultAddress = value;
    },
    async updateAddressBook() {
      if (
        this.name == "" ||
        this.address1 == "" ||
        this.city == "" ||
        this.states == "" ||
        this.zipcode == ""
      ) {
        this.error = "Please enter information for all required fields";
        this.isErrorShake = true;
        setTimeout(() => {
          this.isErrorShake = false;
        }, 800);
      } else {
        let newAdddess = {
          email: this.$store.state.user.email,
          name: this.name,
          address1: this.address1,
          address2: this.address2,
          city: this.city,
          state: this.states,
          zipcode: this.zipcode,
          default: this.defaultAddress
        };
        if (this.defaultAddress) {
          this.$store.dispatch("clearDefaultAddress");
        }
        this.$store.dispatch("addAddress", newAdddess);
        const response = await UserService.updateAddressBook(
          this.$store.state.user.addressBook
        );

        this.$router.push("/addressBook");
      }
    },
    back() {
      this.$router.push("/addressBook");
    }
  }
};
</script>

<style scoped>
.link {
  color: rgb(57, 93, 255);
  margin-bottom: 0px;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

.errorShake {
  /* Start the shake animation and make the animation last for 0.5 seconds */
  animation: shake 0.75s;

  /* When the animation is finished, start again */
  animation-iteration-count: infinite;
}

@keyframes shake {
  0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }
}
</style>
